import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LoggingModule } from "../logging/logging.module";

@NgModule({
  declarations: [],
  imports: [CommonModule, LoggingModule],
})
export class LocalStorageModule {}
